var commerce = {};
module['exports'] = commerce;
commerce.color = require("./color");
commerce.department = require("./department");
commerce.product_name = require("./product_name");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es_MX/commerce/index.js
// module id = 891
// module chunks = 0